module.exports = [
  {
    title: 'Naeris Altair',
    visible: false,
    img: 'img/art/naeris_happy-bg-sig-purple.png',
    desc: 'Naeris knows not of her past, only that she was from an elven civilization who\'s existence is unknown. She was found by a traveling professor of astronomy at a young age. with no memory of her past. The astronomer noticed a map of stars imprinted on Naeris\' back, though did not understand its meaning. During her time with her master, she was able to master her ability in magic from her elven side,and also learn about the vast knowledge of the stars collected by her master. After scrounging enough money, she split from her master in the night to seek knowledge of her past, believing her elven origin was linked to the stars through this mysterious map imprinted on her back. She gave herself the family name "Altair" from the star in the sky shortly after.'
  },
  {
    title: 'Aina from Promare',
    visible: false,
    img: 'img/art/aina_ardebit.png',
    desc: 'Fan art of Aina from Promare. I used her character sheet as a reference.'
  },
  {
    title: 'Naeris Altair Chibi',
    visible: false,
    img: 'img/art/naeris_chibi-bg-sig.png',
    desc: 'Naeris but smol'
  },
  {
    title: 'Rin and Marshy',
    visible: false,
    img: 'img/software/mc_and_marshy.gif',
    desc: 'Rin and Marshy from Saladbox Adventure. A game where you get transported to a land where food can talk'
  },
  {
    title: 'Rin in the Snow',
    visible: false,
    img: 'img/art/rin_standing_on_snow.gif',
    desc: 'Some scenery art for the game that will never be'
  },
]